var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xs":""}},[_c('FhirMap',{attrs:{"accessToken":_vm.accessToken,"fhirServerUrl":_vm.fhirServerUrl,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }